import { initLibTranslation } from './i18n/config-locale';
// Define auto load default language
initLibTranslation('es');
//# sourceMappingURL=setup.js.map